import { render } from "./SelectedNestedLocations.vue?vue&type=template&id=6995af0b&ts=true"
import script from "./SelectedNestedLocations.vue?vue&type=script&lang=ts"
export * from "./SelectedNestedLocations.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__